export class CacheCoordinates
{
    public Latitude: number;
    public Longitude: number;
    public TimeStamp: number;
    
    constructor(
        Latitude: number,
        Longitude: number,
        TimeStamp: number
    ){
        this.Longitude = Longitude;
        this.Latitude = Latitude;
        this.TimeStamp = TimeStamp;
    }
}